// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore, useSessionStore } from '@/store'
import { ROUTES, HOME_ROUTE } from '@/lib/constants/routes'

/**
 * Requires authenticated user session.
 * Does NOT auto-redirect to wizard - the user lands on /home
 * and makes their own choice from there.
 */
export function ProtectedRoute() {
  const { isAuthenticated } = useAuthStore()
  const location            = useLocation()

  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.LOGIN}
        state={{ from: location }}
        replace
      />
    )
  }

  return <Outlet />
}

/** Requires active next-of-kin session */
export function NextOfKinRoute() {
  const { isActive, expiresAt } = useSessionStore()
  const isExpired = expiresAt ? new Date(expiresAt) < new Date() : true
  if (!isActive || isExpired) return <Navigate to={ROUTES.NEXT_OF_KIN_ENTRY} replace />
  return <Outlet />
}

/**
 * Redirects already-logged-in users away from login/onboarding.
 * Always goes to /home - the user decides from there.
 */
export function PublicRoute() {
  const { isAuthenticated } = useAuthStore()
  if (isAuthenticated) {
    return <Navigate to={HOME_ROUTE} replace />
  }
  return <Outlet />
}
